var map = {
	"./About": 2441,
	"./About.vue": 2441,
	"./Admin/Blog": 4892,
	"./Admin/Blog.vue": 4892,
	"./Admin/Categories": 4701,
	"./Admin/Categories.vue": 4701,
	"./Admin/Classifications": 5836,
	"./Admin/Classifications.vue": 5836,
	"./Admin/Config": 4041,
	"./Admin/Config.vue": 4041,
	"./Admin/Dashboard": 3199,
	"./Admin/Dashboard.vue": 3199,
	"./Admin/Fruit/FruitShow": 8874,
	"./Admin/Fruit/FruitShow.vue": 8874,
	"./Admin/Fruit/Index": 1821,
	"./Admin/Fruit/Index.vue": 1821,
	"./Admin/Production": 1914,
	"./Admin/Production.vue": 1914,
	"./Admin/Taxonomy": 7096,
	"./Admin/Taxonomy.vue": 7096,
	"./Admin/Users": 3513,
	"./Admin/Users.vue": 3513,
	"./Blog": 4810,
	"./Blog.vue": 4810,
	"./Classifications": 2308,
	"./Classifications.vue": 2308,
	"./Contact": 8805,
	"./Contact.vue": 8805,
	"./Fruit/FruitCompare": 3708,
	"./Fruit/FruitCompare.vue": 3708,
	"./Fruit/FruitIframe": 929,
	"./Fruit/FruitIframe.vue": 929,
	"./Fruit/FruitIndexIframe": 2992,
	"./Fruit/FruitIndexIframe.vue": 2992,
	"./Fruit/FruitShow": 2069,
	"./Fruit/FruitShow.vue": 2069,
	"./Fruit/FruitsByCategory": 4422,
	"./Fruit/FruitsByCategory.vue": 4422,
	"./Fruit/FruitsByClassification": 317,
	"./Fruit/FruitsByClassification.vue": 317,
	"./Holi": 9270,
	"./Holi.vue": 9270,
	"./Home": 7982,
	"./Home.vue": 7982,
	"./Portfolio/Create": 2475,
	"./Portfolio/Create.vue": 2475,
	"./Portfolio/Farm": 4373,
	"./Portfolio/Farm.vue": 4373,
	"./Portfolio/Harvest": 8905,
	"./Portfolio/Harvest.vue": 8905,
	"./Portfolio/HarvestCreate": 8547,
	"./Portfolio/HarvestCreate.vue": 8547,
	"./Portfolio/Index": 7561,
	"./Portfolio/Index.vue": 7561,
	"./Portfolio/Tree": 2663,
	"./Portfolio/Tree.vue": 2663,
	"./Report/ReportCreate": 8830,
	"./Report/ReportCreate.vue": 8830,
	"./Roadmap": 1161,
	"./Roadmap.vue": 1161,
	"./Taxonomy/Show": 6225,
	"./Taxonomy/Show.vue": 6225,
	"./User/Profile": 8769,
	"./User/Profile.vue": 8769
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3218;